import React from 'react';

const NotFound = () => {

    return (
        <div className="text-center">
            <img src="/images/PageNotFound.png" alt="Page Not Found" className="img-fluid" />
        </div>
    )
}

export default NotFound